// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/superAdmin';
// import router from "../../../router/index";
// import store from '@/store';

const state = {
    // Additional state if needed
    getSubscription: '',
}

const mutations = {
    SET_SUBSCRIPTION_DATA(state, data) {
        state.getSubscription = data
    },
}

const actions = {
    // Additional actions if needed
    getSubscription({ commit }) {
        // return
        // return new Promise((resolve, reject) => {
        axios
            .get(axios.defaults.baseURL + apis.GET_SUBSCRIPTION, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "ngrok-skip-browser-warning": "69420",
                },
            })
            .then((res) => {
                console.log('getSubscription---res !!', res)
                if (res.data.data) {
                    commit('SET_SUBSCRIPTION_DATA', res.data.data)
                }
                else {
                    commit('SET_SUBSCRIPTION_DATA', res.data.message)
                }
            })
            .catch((err) => {
                console.log('getSubscription err', err)
            })
        // })
    },

    
    changeSubscriptionStatus({dispatch }, payload) {
        // return
        console.log('payload---',payload)
        return new Promise((resolve, reject) => {
            axios
                .put(axios.defaults.baseURL + apis.PUT_CHANGE_SUBSCRIPTION_STATUS + payload, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('schanged---res !!', res)
                    dispatch("getSubscription")
                    resolve(res)

                })
                .catch((err) => {
                    reject(err)
                    console.log('changed status err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
};